/* Medicus — "If something is not right, we put it right"
 * ---------------------------------------------------------------------------
 * Rebuilds the head of YMQ's agreement option 542tem4 and shortens the visible
 * text on its confirm button.
 *
 * WHAT IT NEVER TOUCHES: the checkbox, its value, its checked state, its label,
 * and YMQ's own required-field validation. The only things that change are the
 * replaced title/help text above the buttons and where YMQ's terms trigger sits.
 *
 * The terms popup is YMQ's — its trigger element is MOVED into the new block,
 * not copied or rebuilt, so whatever it opens keeps working.
 * --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var FIELD_ID = '542tem4';
  var FIELD_LABEL = /return \+ refund policy|agree to our return/i;

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function readConfig() {
    var node = document.querySelector('[data-mc-terms-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function findBox() {
    var byId = document.querySelector('.ymq-options-box[ymq-option-id="' + FIELD_ID + '"]');
    if (byId) return byId;
    var boxes = all('.ymq-options-box[ymq-option-type="16"]');
    for (var i = 0; i < boxes.length; i++) {
      if (FIELD_LABEL.test(boxes[i].getAttribute('ymq-option-label') || '')) return boxes[i];
    }
    return null;
  }

  function build(cfg, trigger) {
    var c = cfg.copy;
    var wrap = el('section', 'mc-terms');
    wrap.setAttribute('data-mc-terms', '');

    wrap.appendChild(el('h3', 'mc-terms__head', c.heading));

    var list = el('ul', 'mc-terms__list');
    (c.points || []).forEach(function (p) {
      var li = el('li', 'mc-terms__point');
      li.appendChild(el('strong', 'mc-terms__ptitle', p.title));
      li.appendChild(el('span', 'mc-terms__ptext', p.text));
      list.appendChild(li);
    });
    wrap.appendChild(list);

    if (cfg.links && cfg.links.sample) {
      var a = el('a', 'mc-terms__sample', c.sample_cta);
      a.href = cfg.links.sample;
      a.setAttribute('data-mc-event', 'terms_sample');
      wrap.appendChild(a);
    }

    /* YMQ's own trigger, relocated. Its data-ymqmodal-trigger attribute and the
       listener YMQ bound to it travel with the element. */
    if (trigger) {
      var row = el('p', 'mc-terms__full');
      row.appendChild(el('span', 'mc-terms__full-lead', c.terms_lead));
      row.appendChild(document.createTextNode(' '));
      trigger.classList.add('mc-terms__trigger');
      row.appendChild(trigger);
      wrap.appendChild(row);
    }
    return wrap;
  }

  /* NOTHING rewrites the button's text. An earlier build shortened it, and YMQ
     re-rendered the label straight back — its own observer against mine, a
     rewrite loop that locked the tab. The wording on the button is YMQ's; the
     duplication is dealt with by hiding the title and help text instead. */

  function mount(cfg) {
    var box = findBox();
    if (!box) return false;
    if (box.querySelector('[data-mc-terms]')) return true;

    var title = box.querySelector('.ymq-option-title');
    var help = box.querySelector('.ymq-option-help-text');
    var trigger = box.querySelector('.ymq-option-popup[data-ymqmodal-trigger]');
    var block = build(cfg, trigger);

    if (title) { title.parentNode.insertBefore(block, title); title.hidden = true; title.classList.add('mc-terms-hidden'); }
    else box.insertBefore(block, box.firstChild);
    if (help) { help.hidden = true; help.classList.add('mc-terms-hidden'); }
    box.classList.add('mc-terms-box');
    return true;
  }

  /* YMQ renders late and re-renders this group whenever a condition changes,
     which throws the block away — so keep watching for the whole session. */

  /* INP fix (7 Sept 2026). YMQ lazy-loads ~930 swatch images over the first
     minute and flips a class on each one as it lands; with five scripts
     watching document.body that was 24s of blocked main thread in the first
     33s of every product page (GSC: product group INP 490ms from 4 Sept).
     Only container-level changes matter to this script; value-level class
     flips, images, the header search box and our own widgets are ignored. */
  var MC_IGNORE_ATTR = '.ymq-option-value,.ymq-option-value-item,.ymq-option-swatches-item,.ymq-option-label,.ymq-option-button-input,img,input,textarea,.search-mega-menu__input';
  var MC_OWN = '[data-mc-fit-card],.mc-fit__check,.mc-emb-cue,.mc-emb-modal,[data-mc-satc],.mc-tellus-box,.mc-terms-box';
  function mcRelevant(records) {
    for (var i = 0; i < records.length; i++) {
      var m = records[i], t = m.target;
      if (t.nodeType !== 1) { t = t.parentElement; if (!t) continue; }
      if (t.closest && t.closest(MC_OWN)) continue;
      if (m.type === 'attributes' && t.matches && t.matches(MC_IGNORE_ATTR)) continue;
      return true;
    }
    return false;
  }

  function start() {
    var cfg = readConfig();
    if (!cfg) return;
    var go = function () { try { return mount(cfg); } catch (e) { return true; } };
    go();
    var tries = 0;
    var timer = setInterval(function () { tries++; if (go() || tries > 60) clearInterval(timer); }, 500);
    try {
      new MutationObserver(function (records) { if (mcRelevant(records)) go(); })
        .observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* YMQ's own block stands */ }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
